class UGCCarousel extends HTMLElement {
  constructor() {
    super();

    this.initialise();
  }

  initialise() {
    this.initCarousel();

    const videos = this.querySelectorAll('[data-video]');
    const playIcons = this.querySelectorAll('[data-play-icon]');
    const pauseIcons = this.querySelectorAll('[data-pause-icon]');
    const muteIcons = this.querySelectorAll('[data-mute-icon]');

    videos.forEach((video, index) => {
      video.addEventListener('mouseover', function() {
          const playPromise = video.play();
          if (playPromise !== undefined) {
              playPromise.then(_ => {
                  playIcons[index].classList.add('ugc-card__icon--hidden');
                  pauseIcons[index].classList.remove('ugc-card__icon--hidden');
              }).catch(error => {
                  console.error('Autoplay was prevented:', error);
              });
          }
      });

      video.addEventListener('mouseout', function() {
          if (!video.paused) {
              video.pause(); 
              playIcons[index].classList.remove('ugc-card__icon--hidden');
              pauseIcons[index].classList.add('ugc-card__icon--hidden');
          }
      });

      function playVideo() {
        video.play();
        playIcons[index].classList.add('ugc-card__icon--hidden');
        pauseIcons[index].classList.remove('ugc-card__icon--hidden');
      }

      function pauseVideo() {
        video.pause();
        playIcons[index].classList.remove('ugc-card__icon--hidden');
        pauseIcons[index].classList.add('ugc-card__icon--hidden');
      }

      function toggleMute() {
        video.muted = !video.muted;
        muteIcons[index].setAttribute('aria-pressed', video.muted ? 'true' : 'false');
      }

      playIcons[index].addEventListener('click', playVideo);
      playIcons[index].addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); playVideo(); } });

      pauseIcons[index].addEventListener('click', pauseVideo);
      pauseIcons[index].addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pauseVideo(); } });

      muteIcons[index].addEventListener('click', toggleMute);
      muteIcons[index].addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMute(); } });
    });
  }

  initCarousel() {
    // Wait for Swiper to be available
    if (!window.Swiper) {
      // Swiper not loaded yet, wait for it
      const checkSwiper = setInterval(() => {
        if (window.Swiper) {
          clearInterval(checkSwiper);
          this.initCarousel();
        }
      }, 50);
      // Timeout after 5 seconds
      setTimeout(() => {
        clearInterval(checkSwiper);
        if (!window.Swiper) {
          console.error('Swiper library failed to load');
        }
      }, 5000);
      return;
    }
    
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      lazy: true,
      slidesPerView: 1.5,
      spaceBetween: 12,
      navigation: {
        nextEl: this.querySelector('[data-ugc-next]'),
        prevEl: this.querySelector('[data-ugc-prev]')
      },
      scrollbar: {
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      // modules: [Swiper.Navigation, Swiper.Scrollbar],
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 24,
        }
      }
    });
  }

}

customElements.define('ugc-carousel', UGCCarousel);
